import React from 'react'

import MagicLinkEmailPasswordForm from './MagicLinkEmailPasswordForm'

function SignUp() {
  return <MagicLinkEmailPasswordForm type="signup" />
}

export default SignUp
